import { useEffect } from "react";
import "../../assets/volunteers.css";
import eventLogo from "../../assets/eventLogo.png";
import { volunteerStatus } from "../../lib/services/authService";
import { useNavigate } from "react-router-dom";

import StencilDisplay from "../components/StencilDisplay";

export default function VolunteerConfirm({
  setIsVolunteerAuthenticated,
  setStencilData,
  stencilData,
  volunteerName,
}) {
  useEffect(() => {
    const checkVolunteerStatus = async () => {
      const response = await volunteerStatus();
      if (response.ok) {
        const data = await response.json();
        setIsVolunteerAuthenticated(data.isAuthenticated);
      }
    };

    checkVolunteerStatus();
  }, []);

  const navigate = useNavigate();

  return (
    <div className="vol-wrap">
      <div className="vol-stack">
        {/* Brand logo above the card */}
        <img
          src={eventLogo}
          alt="Spirits in the Gardens"
          className="vol-logo"
          loading="eager"
        />
        <div className="vol-card">
          <StencilDisplay
            stencilData={stencilData}
            volunteerName={volunteerName}
          />
        </div>
        {/* BUTTONS OUTSIDE THE CARD */}
        <div className={`vol-actions-outside grid-2`}>
          <button
            className="vol-btn primary"
            onClick={() => navigate("/volunteer/timer")}
          >
            Confirm
          </button>
          <button
            className="vol-btn ghost"
            onClick={() => {
              setStencilData(null);
              navigate("/volunteer/landing");
            }}
          >
            Back
          </button>
        </div>
      </div>
    </div>
  );
}
